export const MOTIVES = {
  HABILITACAO: 'Habilitação',
  REPARO: 'Reparo',
}

export const STATUS = {
  SCHEDULE: 'AGENDADA',
}
